import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Card, CardTitle } from "react-bootstrap";
import "../../assets/css/Secretsanta.css";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { FileUpload } from "primereact/fileupload";

const Wishlist = () => {
    const [visibleRight, setVisibleRight] = useState(false);
    const [visibleRight2, setVisibleRight2] = useState(false);
    const [value, setValue] = useState("");
    const [file, setFile] = useState(null);
    const [showInitialCard, setShowInitialCard] = useState(true);
    const [showSecondCard, setShowSecondCard] = useState(false);

    const toast = useRef(null);

    const onSelectFile = (e) => {
        const selectedFile = e.files[0];
        const imgURL = URL.createObjectURL(selectedFile);
        setFile({ raw: selectedFile, preview: imgURL });
    };

    const removeImage = () => {
        setFile(null);
    };

    const handleGiftUploadSave = () => {
        if (!file || !value) {
            toast.current.show({ severity: "warn", summary: "Warning", detail: "All fields required!" });
            return;
        }

        setShowInitialCard(false);
        setShowSecondCard(true);
        setVisibleRight(false);
        toast.current.show({ severity: "success", summary: "Success", detail: "Gift Saved!" });
    };

    /*---------------------gift list selection -----------------------*/

    const [selectedIndex, setSelectedIndex] = useState(null);

    const handleSelect = (index) => {
        setSelectedIndex(index);
    };

    const handleGiftSelectionSave = () => {
        console.log("Selected Gift:", selectedIndex);
        setVisibleRight2(false);
        toast.current.show({ severity: "success", summary: "Success", detail: "Gift Selected!" });
    };


    /*--------------------scratch card -----------------------*/

   const canvasRef = useRef(null);
    const formRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return; // <-- prevents null errors

        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        const width = canvas.width;
        const height = canvas.height;

        let isDrawing = false;

        ctx.fillStyle = "#b3b3b3";
        ctx.fillRect(0, 0, width, height);

        const getPoint = (e) => {
        const rect = canvas.getBoundingClientRect();
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
        return {
            x: clientX - rect.left,
            y: clientY - rect.top,
        };
        };

        const scratch = (x, y) => {
        ctx.globalCompositeOperation = "destination-out";
        ctx.beginPath();
        ctx.arc(x, y, 25, 0, Math.PI * 2);
        ctx.fill();
        };

        const start = (e) => {
        isDrawing = true;
        const point = getPoint(e);
        scratch(point.x, point.y);
        };

        const move = (e) => {
        if (!isDrawing) return;
        const point = getPoint(e);
        scratch(point.x, point.y);
        };

        const end = () => {
        isDrawing = false;

        const pixels = ctx.getImageData(0, 0, width, height);
        let cleared = 0;

        for (let i = 3; i < pixels.data.length; i += 4) {
            if (pixels.data[i] === 0) cleared++;
        }

        if (cleared / (width * height) > 0.3) {
            canvas.style.opacity = "0";
            formRef.current.style.visibility = "visible";
        }
        };

        canvas.addEventListener("mousedown", start);
        canvas.addEventListener("mousemove", move);
        canvas.addEventListener("mouseup", end);
        canvas.addEventListener("mouseleave", end);

        // Touch support
        canvas.addEventListener("touchstart", start);
        canvas.addEventListener("touchmove", move);
        canvas.addEventListener("touchend", end);

        return () => {
        canvas.removeEventListener("mousedown", start);
        canvas.removeEventListener("mousemove", move);
        canvas.removeEventListener("mouseup", end);
        canvas.removeEventListener("mouseleave", end);

        canvas.removeEventListener("touchstart", start);
        canvas.removeEventListener("touchmove", move);
        canvas.removeEventListener("touchend", end);
        };
    }, []);







    return (
        <>
            <Toast ref={toast}></Toast>

            {/* FIRST CARD */}
            {showInitialCard && (
                <Row className="body_content santabg">
                    <Col lg={3} className="fade-in">
                        <Card className="shadow p-3 text-center">
                            <CardTitle>Hi! <em>{"John"}</em></CardTitle>
                            <Button
                                label="Upload Gift Snap"
                                severity="danger"
                                className="py-2 d-block mt-4"
                                onClick={() => setVisibleRight(true)}
                            />
                        </Card>
                    </Col>
                    <video autoPlay loop muted playsInline className="bg_video">
                        <source src="https://blackboxstorage.blr1.cdn.digitaloceanspaces.com/assetImages/christmas%20loop%202.mp4" type="video/mp4" />
                    </video>
                </Row>
            )}

            {/* SECOND CARD */}
            {showSecondCard && (
                <Row className="body_content secondSantabg">
                    <Button
                        label="Select your secret santa"
                        severity="danger"
                        className="py-2 mt-4 "
                        onClick={() => {
                            setShowSecondCard(false);
                            setShowInitialCard(false);
                        }}
                    />
                </Row>
            )}

            {/* PROFILE CARD */}
            {!showInitialCard && !showSecondCard && (
                <Row className="body_content overflow-hidden">
                    <Col lg={12} className="fade-up p-0">
                        {/* <aside className="profile-card shadow">
                            <header>
                                <img
                                    src="https://demoadmin.thegraphe.com/admin/static/media/no_user.6f678b05521261910525.png"
                                    alt="Avatar"
                                    className="hoverZoomLink"
                                />
                                <h1><em>John Doe</em></h1>
                                <h2>Better Visuals</h2>
                                <Button
                                    label="Select Gift"
                                    icon="pi pi-gift"
                                    severity="help"
                                    className="py-2 d-block mt-4 w-100"
                                    onClick={() => setVisibleRight2(true)}
                                />
                                <div className="gftText">
                                    <img src="https://confettigifts.in/cdn/shop/files/IMG_9378_1_1.jpg?v=1757329958" alt="giftimage" />
                                    <p>
                                        <span className="wrap-text">
                                            https://confettigifts.in/products/5-senses?
                                        </span>
                                    </p>
                                </div>
                            </header>
                        </aside> */}
                        <div className="scratch-container">
                        <canvas
                            ref={canvasRef}
                            width={300}
                            height={300}
                            className="scratch-canvas"
                        ></canvas>
                        <form ref={formRef} className="secret-form">
                            <h2>'Allo, 'Allo!</h2>
                            <h3>The secret code is:</h3>
                            <h1><code>HlkafSYc</code></h1>
                        </form>
                        </div>
                    </Col>

                    <video autoPlay loop muted playsInline className="bg_video">
                        <source src="https://blackboxstorage.blr1.cdn.digitaloceanspaces.com/assetImages/Christmas%201%20loop.mp4" type="video/mp4" />
                    </video>
                </Row>
            )}

            {/* IMAGE UPLOAD SIDEBAR */}
            <Sidebar
                visible={visibleRight}
                position="right"
                onHide={() => setVisibleRight(false)}
                dismissable={false}
                style={{ width: "450px" }}
            >
                <h5 className="mb-4 pb-3 border-bottom text-danger">Upload Gift Data</h5>

                <div className="mb-3">
                    <label className="mb-2">Gift Image *</label>
                    {!file ? (
                        <FileUpload
                            mode="basic"
                            accept="image/*"
                            maxFileSize={1000000}
                            auto
                            customUpload
                            chooseLabel="Choose Image"
                            onSelect={onSelectFile}
                        />
                    ) : (
                        <div className="preview-container position-relative">
                            <img src={file.preview} className="preview-img rounded w-100" alt="preview" />
                            <Button
                                icon="pi pi-trash"
                                severity="danger"
                                rounded
                                className="delete-btn position-absolute"
                                onClick={removeImage}
                            />
                        </div>
                    )}
                </div>

                <div className="mb-3">
                    <label className="mb-2">Gift URL Link *</label>
                    <InputText
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        className="w-100"
                        placeholder="Enter product link"
                    />
                </div>

                <Button
                    label="Save Gift"
                    severity="danger"
                    className="py-2 mt-4 d-block w-100"
                    onClick={handleGiftUploadSave}
                />
            </Sidebar>

            {/* GIFT SELECTION SIDEBAR */}
            <Sidebar
                visible={visibleRight2}
                position="right"
                onHide={() => setVisibleRight2(false)}
                dismissable={false}
                style={{ width: "450px" }}
                className="giftslid"
            >
                <h5 className="mb-4 pb-3 border-bottom text-danger">Select Gift</h5>

                <ul className="gift-list">
                    {["Gift A", "Gift B", "Gift C"].map((item, index) => (
                        <li
                            key={index}
                            onClick={() => handleSelect(index)}
                            className={selectedIndex === index ? "selected-li" : ""}
                        >
                            <div className="gftText">
                                <img src="https://confettigifts.in/cdn/shop/files/IMG_9378_1_1.jpg?v=1757329958" alt="giftimage" />
                                <p>
                                    <span>
                                        https://confettigifts.in/products/5-senses
                                    </span>
                                </p>
                            </div>
                        </li>
                    ))}
                </ul>

                {selectedIndex !== null && (
                    <Button
                        label="Save Gift"
                        severity="danger"
                        className="py-2 mt-4 d-block w-100"
                        onClick={handleGiftSelectionSave}
                    />
                )}
            </Sidebar>
        </>
    );
};

export default Wishlist;
